import { Component, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { CampService } from '../../../shared/service/camp.service';
import { AbstractCampOngletCampFormComponent } from '../abstract-camp-onglet-camp-form.component';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CampStructure, ICampStructure } from '../../../shared/model/camp-structure.model';
import { IStructure } from '../../../shared/model/structure.model';
import { SelectionModel } from '@angular/cdk/collections';
import { ICamp } from '../../../shared/model/camp.model';
import { StructureService } from '../../../shared/service/structure.service';
import { filterOkMapBody } from '../../../shared/util/http.utils';
import { SnackBarService } from '../../../shared/service/snackbar.service';
import { AdherentService } from '../../../shared/service/adherent.service';
import { IAdherent } from '../../../shared/model/adherent.model';
import {
  CampCodeModulesEnum,
  CampFichierCategorieEnum,
  CampModuleEnum,
  TypeCampGroupEnum,
  TypeSoutienEnum
} from '../../../shared/constant/enum';
import { CampAdherentSoutien, ICampAdherentSoutien } from '../../../shared/model/camp-adherent-soutien.model';
import { HandlableError } from '../../../shared/interceptor/error-handler.interceptor';
import {
  checkCampStructuresOrganizers,
  checkCodeEntry,
  checkDates,
  checkNbreJeunes
} from '../../../shared/util/form-validator.utils';
import {CAMP_INFO_GENERALE_STATUS, NB_MAX} from '../../../shared/constant/constant';
import { ActivatedRoute } from '@angular/router';
import { HistoModificationService } from "../../../shared/service/histo-modification.service";
import { DdcFileService } from '../../../shared/service/ddc-file.service';
import { HttpResponse } from '@angular/common/http';
import { IDdcFichier } from '../../../shared/model/camp-fichier.model';
import { AuthenticationService } from '../../../shared/service/authentication.service';
import { IDdcUser } from '../../../shared/model/ddc-user.model';
import { isCampModulesActive } from '../../../shared/util/camp-utils';
import moment from 'moment';
import { GenerateDossierCampService } from '../../../shared/service/generate-dossier-camp.service';
import {DdcMatDialogService} from '../../../shared/service/ddc-mat-dialog.service';
import { filter, switchMap, take } from 'rxjs/operators'

@Component({
    selector: 'ddc-camp-onglet-informations-generales',
    templateUrl: './camp-onglet-informations-generales.component.html',
    styleUrls: ['./camp-onglet-informations-generales.component.scss'],
    standalone: false
})
export class CampOngletInformationsGeneralesComponent extends AbstractCampOngletCampFormComponent {
  //todo  remove the commentary

  public static readonly MODULE_NAME = CampCodeModulesEnum.INFO_GENERALE;

  structuresDisponiblesTableSelectionModel = new SelectionModel<IStructure>(true, []);
  structuresTableDataSource = new MatTableDataSource<IStructure>([]);
  structuresTableDisplayedColumns = ['libelle', 'ajouter'];

  campStructuresTableDataSource = new MatTableDataSource<ICampStructure>([]);
  campStructuresTableDisplayedColumns = ['libelle', 'organisatrice', 'supprimer'];

  @ViewChild(MatSort, {static: true}) sort: MatSort;

  allStructuresDisponibles: IStructure[] = [];

  codeEntryForm = this.fb.group({
    structure: ['', [checkCodeEntry]],
    ap: ['', [checkCodeEntry]],
    international: ['', [checkCodeEntry]],
    marin: ['', [checkCodeEntry]],
    ac: ['', [checkCodeEntry]],
    vao: ['', [checkCodeEntry]],
    local: ['', [checkCodeEntry]]
  });

  CAMP_INFO_GENERALE_STATUS = CAMP_INFO_GENERALE_STATUS;
  campAdherentSoutiensData = {};
  TypeSoutienEnum = TypeSoutienEnum;
  CampModuleEnum = CampModuleEnum;
  fichiersDossierCamp: IDdcFichier[];
  currentUser: IDdcUser;

  datesInterval = [];


  isCampModulesActive = isCampModulesActive;

  constructor(
    protected campService: CampService,
    private fb: FormBuilder,
    private structureService: StructureService,
    private adherentService: AdherentService,
    protected ddcFileService: DdcFileService,
    protected snackBarService: SnackBarService,
    protected activatedRoute: ActivatedRoute,
    protected histoModificationService: HistoModificationService,
    protected authenticationService: AuthenticationService,
    protected generateDossierCampService: GenerateDossierCampService,
    protected ddcMatDialogService: DdcMatDialogService
  ) {
    super(
      campService,
      CampOngletInformationsGeneralesComponent.MODULE_NAME,
      fb.group({
        libelle: [''],
        statut: [''],
        dateDebut: [''],
        dateFin: [''],
        campStructures: fb.array([], [checkCampStructuresOrganizers]),
        campAdherentSoutiens: fb.array([])
      }),
      activatedRoute,
      snackBarService,
      histoModificationService,
    );

    // Get the current connected user (used to check the rights that the user has)
    this.currentUser = this.authenticationService.currentUserValue;

    // Récupération de l'ensemble des structures disponibles pour l'utilisateur connecté actuellement
    structureService.find()
      .pipe(filterOkMapBody)
      .subscribe((structures: IStructure[]) => {
        // On supprime les structures déjà présents dans la liste des structures sélectionnés
        this.allStructuresDisponibles = structures;
        this.initStructuresDisponiblesTableData();
        this.initCampAdherentSoutiensData();
      });
  }

  ngOnInit() {
    super.ngOnInit();
    this.structuresTableDataSource.sort = this.sort;
  }

  private initStructuresDisponiblesTableData() {
    const campStructuresCodes = new Set<string>(this.getCampStructuresFormArray().getRawValue().map(campStructure => campStructure.structure.code));
    this.structuresTableDataSource.data = this.allStructuresDisponibles.filter(structure => !campStructuresCodes.has(structure.code));
  }

  private initCampAdherentSoutiensData() {
    this.campAdherentSoutiensData = {};
    this.getCampAdherentSoutiensFormArray().getRawValue().forEach((campAherentSoutien: ICampAdherentSoutien) => {
      if (!this.campAdherentSoutiensData[campAherentSoutien.typeSoutien]) {
        this.campAdherentSoutiensData[campAherentSoutien.typeSoutien] = []
      }
      this.campAdherentSoutiensData[campAherentSoutien.typeSoutien].push(campAherentSoutien.adherent);
    });
  }

  updateViewValue(campFormPatchValue: ICamp) {
    // If the type of the camp is camp-8-17, add the camp817 FormGroup to the parent form group before updating the view
    this.initCamp817FormGroup();

    super.updateViewValue(campFormPatchValue);
    const campStructuresFormArray = this.getCampStructuresFormArray();
    campStructuresFormArray.clear();
    campFormPatchValue.campStructures.forEach(campStructure => {
      campStructuresFormArray.push(this.createCampStructureFormGroup(campStructure))
    });
    this.structuresDisponiblesTableSelectionModel.clear();
    this.initStructuresDisponiblesTableData();
    this.initCampStructuresTableData(campStructuresFormArray);
    this.initDatesIntervalAndSetValidators(campFormPatchValue._datesInterval);

    const campAdherentSoutiensFormArray = this.getCampAdherentSoutiensFormArray();
    campAdherentSoutiensFormArray.clear();
    campFormPatchValue.campAdherentSoutiens.forEach(campAdherentSoutien => {
      campAdherentSoutiensFormArray.push(this.createCampAdherentSoutiensFormGroup(campAdherentSoutien))
    });
    this.initCampAdherentSoutiensData();
    this.initFichierDossierCamp();
  }

  private initCamp817FormGroup(): void {
    if (
      this.currentCamp && this.currentCamp.typeCamp &&
      this.currentCamp.typeCamp.codeGroupeCamp === TypeCampGroupEnum.HUIT_DIXSEPT &&
      !this.campForm.get('camp817')
    ) {

      const nbMax = NB_MAX.find(typeCamp => typeCamp.value == this.currentCamp.typeCamp.code).nombreMax;
      this.campForm.addControl('camp817', this.fb.group({
        previsionNbreEquipes: ['', [Validators.min(0), Validators.max(nbMax)]],
        previsionNbreAnimateurs: ['', [Validators.min(0), Validators.max(nbMax)]],
        previsionNbreParticipants: ['', [Validators.min(0), Validators.max(nbMax)]],
        previsionNbreFilles: ['', [Validators.min(0), Validators.max(nbMax)]],
        previsionNbreGarcons: ['', [Validators.min(0), Validators.max(nbMax)]],
        previsionNbre613: ['', [Validators.min(0), Validators.max(nbMax)]],
        previsionNbre1417: ['', [Validators.min(0), Validators.max(nbMax)]],
        ageMini: ['', [Validators.min(0), Validators.max(nbMax)]],
        ageMaxi: ['', [Validators.min(0), Validators.max(nbMax)]],
        previsionNbreHandicap: ['', [Validators.min(0), Validators.max(nbMax)]]
      }));
    }
  }

  private initCampStructuresTableData(campStructuresFormArray) {
    this.campStructuresTableDataSource.data = campStructuresFormArray && campStructuresFormArray.controls || [];
  }

  private initFichierDossierCamp() {
    this.ddcFileService.getFilesByDdcIdAndDdcTypeAndCategorie(this.idCamp, this.TypeDossierEnum.CAMP, CampFichierCategorieEnum.DOSSIER_CAMP)
      .subscribe((res: HttpResponse<IDdcFichier[]>) => {
        if (res && res.body && res.body.length > 0) {
          this.fichiersDossierCamp = res.body;
        }
      });
  }

  private getCampStructuresFormArray(): FormArray {
    return this.campForm.get('campStructures') as FormArray;
  }

  private getCampAdherentSoutiensFormArray(): FormArray {
    return this.campForm.get('campAdherentSoutiens') as FormArray;
  }

  ajouterStructuresDisponiblesSelectionnes(index: number) {
    const campStructuresFormArray = this.getCampStructuresFormArray();
    const structure: IStructure = this.structuresTableDataSource.data[index];
    const campStructure = new CampStructure();
    campStructure.organisatrice = false;
    campStructure.participante = true;
    campStructure.structure = structure;
    if (campStructuresFormArray.length === 0) {
      campStructure.organisatrice = true;
    }
    campStructure.id = 0;
    campStructuresFormArray.push(this.createCampStructureFormGroup(campStructure));
    this.structuresDisponiblesTableSelectionModel.clear();
    this.initStructuresDisponiblesTableData();
    this.initCampStructuresTableData(campStructuresFormArray);
  }

  supprimerCampStructureSelectionne(index: number) {
    const campStructuresFormArray = this.getCampStructuresFormArray();
    campStructuresFormArray.removeAt(index);
    this.initStructuresDisponiblesTableData();
    this.initCampStructuresTableData(campStructuresFormArray);
  }

  private createCampStructureFormGroup(campStructure) {
    const formGroup = this.fb.group(new CampStructure);
    formGroup.patchValue(campStructure);
    return formGroup;
  }

  private createCampAdherentSoutiensFormGroup(campAdherentSoutien: ICampAdherentSoutien) {
    const formGroup = this.fb.group(new CampAdherentSoutien());
    formGroup.patchValue(campAdherentSoutien);
    return formGroup;
  }

  supprimeCampAdherentSoutien(adherent: IAdherent, typeSoutien: TypeSoutienEnum) {
    const campAdherentsSoutien = this.getCampAdherentSoutiensFormArray().getRawValue() || [];
    const index = campAdherentsSoutien.findIndex(
      (campAdherentSoutien: ICampAdherentSoutien) => campAdherentSoutien.adherent.numero === adherent.numero && campAdherentSoutien.typeSoutien === typeSoutien
    );
    if (index !== -1) {
      this.getCampAdherentSoutiensFormArray().removeAt(index)
      this.initCampAdherentSoutiensData();
    }
  }

  toggleFlagOrganisatrice(campStructure: FormControl) {
    let value = campStructure.value;
    value.organisatrice = !value.organisatrice;
    campStructure.setValue(value);
  }

  adherentDoesExist(adherent: IAdherent, typeSoutien: TypeSoutienEnum) {
    const campAdherentsSoutien = this.getCampAdherentSoutiensFormArray().getRawValue() || [];
    const index = campAdherentsSoutien.findIndex(
      (campAdherentSoutien: ICampAdherentSoutien) => campAdherentSoutien.adherent.numero === adherent.numero && campAdherentSoutien.typeSoutien === typeSoutien
    );
    return index === -1 ? false : true;
  }

  addStructureByCodeEntry() {
    const value = this.codeEntryForm.get('structure').value;
    const code = parseInt(value, 10);
    this.structureService.findByNumero(code)
      .pipe(filterOkMapBody)
      .subscribe(
        (structure: IStructure) => {
          if (structure) {
            const campStructuresCodes = new Set<string>(this.getCampStructuresFormArray().getRawValue().map(campStructure => campStructure.structure.code));
            const presenceFlag = campStructuresCodes.has(structure.code);
            if (!presenceFlag) {
              const campStructuresFormArray = this.getCampStructuresFormArray();
              const campStructure = new CampStructure();
              campStructure.organisatrice = false;
              campStructure.participante = true;
              campStructure.structure = structure;
              campStructure.id = 0;
              if (campStructuresFormArray.length === 0) {
                campStructure.organisatrice = true;
              }
              campStructuresFormArray.push(this.createCampStructureFormGroup(campStructure));
              this.structuresDisponiblesTableSelectionModel.clear();
              this.initStructuresDisponiblesTableData();
              this.initCampStructuresTableData(campStructuresFormArray);
              this.codeEntryForm.get('structure').setValue('');
            } else {
              this.codeEntryForm.get('structure').setErrors({errorMessage: 'La structure est déjà ajoutée'});
            }
          } else {
            this.codeEntryForm.get('structure').setErrors({errorMessage: 'Le code structure que vous avez saisi est inconnu'});
          }
        },
        (err: HandlableError) => {
          if (err && err.error.status === 404) {
            this.codeEntryForm.get('structure').setErrors({errorMessage: 'Le code structure que vous avez saisi est inconnu'});
            err.markAsHandled();
          }
        }
      );
  }

  getAdherentByCode(typeSoutien: TypeSoutienEnum, control: AbstractControl) {
    if (control && control.value) {
      const codeAdherent = control.value;
      this.adherentService.findByNumero(codeAdherent)
        .pipe(filterOkMapBody)
        .subscribe(
          (adherent: IAdherent) => {
            if (adherent) {
              if (!this.adherentDoesExist(adherent, typeSoutien)) {
                const campAdherentSoutiensFormArray = this.getCampAdherentSoutiensFormArray();
                const campAdherentSoutien = new CampAdherentSoutien();
                campAdherentSoutien.id = 0;
                campAdherentSoutien.typeSoutien = typeSoutien;
                campAdherentSoutien.adherent = adherent;
                campAdherentSoutiensFormArray.push(this.createCampAdherentSoutiensFormGroup(campAdherentSoutien));
                this.initCampAdherentSoutiensData();
                control.setValue('');
              } else {
                control.setErrors({errorMessage: 'L\'adhérent a déjà été ajouté'});
              }
            } else {
              control.setErrors({errorMessage: 'Le code adherent que vous avez saisi est inconnu'});
            }
          },
          (err: HandlableError) => {
            if (err && err.error.status === 404) {
              control.setErrors({errorMessage: 'Le code adherent que vous avez saisi est inconnu'});
              err.markAsHandled();
            }
          }
        );
    }
  }

  generatePdf() {
    this.isSaving = true;
    this.generateDossierCampService.printSurveyJSModules(this.currentCamp).then(res => {
      this.fichiersDossierCamp = [res];
      this.isSaving = false;
    }).catch(err => {
      this.isSaving = false;
    });
  }

  initDatesIntervalAndSetValidators(res: any[]) {
    let moduleName = CampOngletInformationsGeneralesComponent.MODULE_NAME;
    this.datesInterval.push(moment(res[0]));
    this.datesInterval.push(moment(res[1]));
    this.campForm.setValidators(
      [
        checkDates(
          'dateDebut',
          'dateFin',
          [this.datesInterval[0], this.datesInterval[1]],
          'Choisissez une date qui appartient à l\'intervalle défini'
        )
        , checkNbreJeunes('camp817', moduleName)
      ],
    )
  }
  openDialogChangeDatePresenceForStaffsAndJeunes() {
    this.ddcMatDialogService.openConfirmActionDialog({
      content: 'Les dates du camp ont été modifiées.<br/><br/>'
               + 'Attention, les éléments en dehors des nouvelles dates du camp dans l\'onglet « Menus » et l\'onglet de la « Grille d\'activités » ont été supprimés.'
               + '<br/><br/>Souhaitez-vous également modifier les dates de présence des participants (maitrise, jeunes) ?',
      confirmText: 'Oui',
      cancelText: 'Non',
      confirmAction: () => {
        this.save()
        // Changing "dates presence participants" if the module is correctly saved once, then unsubscribes
        this.campService.savingEmitter
              .pipe(take(1),
                    filter(saved => saved),
                    switchMap(() => this.campService.modifierDatePresenceParticipants(this.currentCamp.id)),
                    filterOkMapBody)
              .subscribe();
      },
      cancelAction: () => this.save()

    });
  }

  checkDatesAndSave() {
    if(!this.currentCamp.dateFin.isSame((this.campForm.get('dateFin').value)) || !this.currentCamp.dateDebut.isSame((this.campForm.get('dateDebut').value))) {
      this.openDialogChangeDatePresenceForStaffsAndJeunes()
    } else {
      this.save();
    }
  }


}


